'use strict';

angular.module('licensure.services')
    .factory('IPVisits', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {

        return {
            get: function (userOnly, month, year, service_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPVisits', {
                    params: {
                        userOnly: userOnly,
                        month: month,
                        year: year,
                        service_id: service_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getList: function (month, year) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPVisits/getlist', {
                    params: {
                        month: month,
                        year: year
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getYears: function () {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.get('year', 'INSPECTIONS').then(function (yearObject) {
                        d.resolve(yearObject.years);
                    })
                }
                else {
                    $http.get(apiLocation + '/api/IPVisits/getyears', {
                        params: {

                        }
                    })
                        .then(function (response) {
                            var yearObject = {};
                            yearObject.MODULENAME = 'INSPECTIONS';
                            yearObject.years = response.data;

                            Cache.save('year', yearObject, 'MODULENAME').then(function () {
                                d.resolve(response.data);
                            })
                        })
                        .catch(function (response) {
                            console.log(response.data);
                            // handle error
                        });
                }

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPVisits/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (visit) {
                var d = $q.defer();
                if (visit.date_time_set && visit.inspection_date_time) {
                    // Should be in Date format of: day month dd yyyy hh:mm:ss timeZoneOffset (timeZoneName)
                    const timeArr = visit.inspection_date_time.toString().split(' ');
                    if (timeArr.length >= 7) {
                        const timeFormat = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
                        if (timeFormat.test(timeArr[4])) {
                            visit.inspection_time_cf = timeArr[4] + ' ' + timeArr.slice(6).join(' ');;

                            const inspectionDate = new Date(visit.inspection_date_time);
                            const month = ('0' + (inspectionDate.getMonth() + 1)).slice(-2); // Months are zero-based
                            const day = ('0' + inspectionDate.getDate()).slice(-2);
                            const year = inspectionDate.getFullYear();
                            visit.inspection_date_cf = month + '/' + day + '/' + year;
                        }
                    }
                }

                var method = 'POST';
                var url = apiLocation + '/api/IPVisits/';
                if (!isUndefined(visit.id)) {
                    method = 'PUT'
                    url += visit.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        visit: visit,
                        inspections: visit.inspections,
                        inspectors: visit.inspectors,
                        service_template: visit.service_template,
                        vehicle_template: visit.vehicle_template
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            postSpotCheckInspection: function (spotCheckInfo) {
                var d = $q.defer();
                $http.post(apiLocation + '/api/IPVisits/spotCheckInspection', spotCheckInfo)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;